export default __webpack_public_path__ + "static/media/icon_endtype_BarEnd.f88abf2f.png";